import axios from 'axios';

const HEALTH_API_URL = process.env.REACT_APP_API_URL + '/healthdata';

export const getHealthData = async (userId) => {
    try {
        const response = await axios.get(`${HEALTH_API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching health data:', error);
        throw error;
    }
};

// Triggers an on-demand Fitrockr pull for a user (used by the manual Refresh button),
// so MongoDB gets the latest Garmin data before we re-read it. Non-fatal: if the user
// isn't linked to Garmin or the pull fails, the caller still re-reads existing data.
export const triggerFitrockrSync = async (userId, days = 3) => {
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/fitrockr/sync/${userId}`, { days });
    } catch (error) {
        console.warn('Fitrockr sync failed (non-fatal):', error?.response?.data || error.message);
    }
};
